"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.machineJSON = exports.createMachine = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _xstate = require("xstate");
var API = _interopRequireWildcard(require("../../lib/api"));
var _constants = require("../../lib/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ANSWER
} = _constants.events;
const {
  init,
  idle,
  error,
  done,
  pending,
  warning,
  skipped
} = _constants.states;
const machineJSON = _ref => {
  let {
    id = _constants.machineId,
    providerId,
    csrfToken,
    steps,
    /** Data sent in query param `context` in `POST` req to GX API `/api/gx/protocol/${protocolId}/node/${stepId}` */
    externalContext,
    ...rest
  } = _ref;
  return {
    id,
    initial: init,
    context: {
      csrfToken,
      providerId,
      curStep: steps && steps.length > 0 ? steps[0] : null,
      // Converted from an object to an array as object key order is not always reliable
      // This allows us to loop through the steps and render each question in a consistent order
      steps: steps || [],
      externalContext,
      ...rest
    },
    on: {
      [ANSWER]: {
        target: pending,
        actions: 'setStepResponse'
      }
    },
    states: {
      [init]: {
        always: [{
          // If user has already done a clinical keyword search before GX, then any Clinical Validation question will be skipped.
          cond: 'skipQuestion',
          actions: 'syncCurrentStep',
          target: skipped
        }, {
          target: idle
        }]
      },
      [idle]: {},
      [pending]: {
        invoke: {
          id: 'sendAnswer',
          src: 'sendAnswer',
          onDone: [{
            // Return to the idle state if we have more questions to answer
            cond: 'hasAdditionalQuestions',
            actions: 'syncCurrentStep',
            target: idle
          }, {
            cond: 'isInvalidAnswer',
            actions: 'syncCurrentStep',
            target: warning
          }, {
            actions: 'syncCurrentStep',
            target: done
          }],
          onError: error
        }
      },
      [done]: {},
      [warning]: {},
      [error]: {},
      [skipped]: {}
    }
  };
};
exports.machineJSON = machineJSON;
const guards = {
  skipQuestion: ctx => {
    var _context;
    if (!ctx.steps || ctx.steps.length === 0) return true;
    const {
      control,
      controlType,
      question,
      nodeType
    } = ctx.steps[0];
    const shouldSkip = nodeType === _constants.apiResponseStates.DONE || control === null || !(0, _includes.default)(_context = (0, _values.default)(_constants.uiControls)).call(_context, controlType) || !question;
    return shouldSkip;
  },
  isInvalidAnswer: (ctx, ev) => ev.data.nodeType === _constants.apiResponseStates.WARNING,
  // As long as the next node isn't a terminating node (i.e. warning or done), then we have additional questions
  hasAdditionalQuestions: (ctx, ev) => ev.data.nodeType !== _constants.apiResponseStates.WARNING && ev.data.nodeType !== _constants.apiResponseStates.DONE && !!ev.data.question
};
const actions = {
  setStepResponse: (0, _xstate.assign)((ctx, ev) => {
    const {
      steps
    } = ctx;
    const {
      step,
      answer
    } = ev.data;
    const stepIdx = (0, _findIndex.default)(steps).call(steps, s => s.id === step.id);
    const newSteps = [...(0, _slice.default)(steps).call(steps, 0, stepIdx), {
      ...step,
      answer
    }];
    return {
      ...ctx,
      curStep: newSteps[newSteps.length - 1],
      steps: newSteps
    };
  }),
  /**
   * When we receive data from the server, we'll sync our local version with it.
   * This includes things like tracking data and error messages.
   */
  syncCurrentStep: (0, _xstate.assign)((ctx, ev) => {
    if (ev === null) {
      return {
        ...ctx,
        curStep: steps[steps.length - 1]
      };
    }
    const {
      data = {}
    } = ev;
    const {
      tracking,
      message
    } = data;
    const {
      curStep,
      steps
    } = ctx;
    const stepIdx = (0, _findIndex.default)(steps).call(steps, s => s.id === curStep.id);
    const newSteps = [...(0, _slice.default)(steps).call(steps, 0, stepIdx), {
      ...steps[stepIdx],
      ...(tracking ? {
        tracking
      } : {}),
      ...(message ? {
        message
      } : {})
    }, data];
    return {
      ...ctx,
      curStep: newSteps[newSteps.length - 1],
      steps: newSteps
    };
  })
};
const services = {
  sendAnswer: ctx => {
    const {
      curStep,
      providerId,
      productName,
      csrfToken,
      externalContext
    } = ctx;
    const body = {
      csrfToken: csrfToken,
      stepId: curStep.id,
      protocolId: curStep.flowId,
      providerId: providerId,
      productName: productName,
      answer: curStep.answer,
      context: externalContext
    };
    return API.sendGxStepAnswer(body);
  }
};
const makeConfig = () => ({
  actions,
  guards,
  services
});
exports.makeConfig = makeConfig;
const createMachine = _ref2 => {
  let {
    config = makeConfig(),
    ...props
  } = _ref2;
  return (0, _xstate.Machine)(machineJSON(props)).withConfig(config);
};
exports.createMachine = createMachine;